// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"2c1021ba","921":"2e322aa1"}[chunkId] + ".chunk.js";
};